<template>
                <div ref="toastTopRight" class="toast position-fixed top-0 end-0 m-2" style="z-index: 1080" role="alert" aria-live="assertive" aria-atomic="true">
                    <div class="toast-body toast-danger d-flex justify-content-between">
                        {{ toastMessage }}  <!-- Отобразите текст сообщения -->
                        <a href="javascript:;" class="text-success ms-2" data-bs-dismiss="toast">DISMISS</a>
                    </div>
                </div>
</template>

<script setup>
    import { onMounted, ref } from "vue";
    import "/src/assets/sass/scrollspyNav.scss";
    import highlight from "/src/components/plugins/highlight.vue";
    import { useMeta } from "/src/composables/use-meta";
    import { io } from "socket.io-client";
    import {useStore} from "vuex";

    const store = useStore();
    useMeta({ title: "Notifications" });

    const toastMessage = ref(""); // Создайте реактивное значение для сообщения
    let toastTopRight = ref(null);

    onMounted(() => {
       
        initWebSocket(); // Инициализируйте WebSocket
    });

    const initToast = () => {
       
    };

    // Функция для инициализации WebSocket
    const initWebSocket = () => {
     

      const socket = io('https://vrf-dev.teamdaichi.ru'); // или используйте IP-адрес вашего сервера

      socket.on('connect', () => {
        console.log('Успешно подключено к серверу');
      });

      socket.on('notification', (data) => {
        console.log('Получено сообщение:', data);
        let userId = localStorage.getItem('userId')
          if(userId === data.recipient){
              toastTopRight.value = new window.bootstrap.Toast(toastTopRight.value);
              toastMessage.value = `Получатель: ${data.recipient} Тема: ${data.subject}
                    Сообщение: ${data.content}`; // Сохраните сообщение в реактивной переменной

              // TODO сделать отправку в заисимости от  ${data.recipient}
              toastTopRight.value.show(); // Показать уведомление
              store.dispatch('fetchGetNotificationsByRecipient')
          }
      });

      socket.on('disconnect', () => {
        console.log('Отключено от сервера');
      });
    };
</script>
